export function raise_error() {
  alert('Sorry, there has been an error. Please try refreshing the page. If the error persists please contact support.');
}

let cartPayload = (response) => {
  return {
    products: response.products,
    deliveryGrossPrice: response.delivery_gross_cost,
    productsGrossPrice: response.products_gross_cost,
    productsGstPrice: response.products_gst_cost,
    deliveryGstPrice: response.delivery_gst_cost,
    cartGrossPrice: response.gross_total,
    gstEnabled: response.gst_enabled,
    shippingMethod: response.shipping_method,
    isBulky: response.is_bulky,
    status: response.status,
    boundBuyerId: response.buyer_id,
  };
};

export function createCart(buyerId, sellerPid, cb) {
  axios(
    {
      method: 'POST',
      url: `/sfdata/s/${sellerPid}/c`,
      data: {
        buyer_id: buyerId,
      },
    },
  ).then(function(response) {
    cb(response.data.pid);
  }).
  catch(function() {
    raise_error();
  });
}

export function addProductToServerCart(cartId, sellerPid, order, cb) {
  axios(
    {
      method: 'POST',
      url: `/sfdata/s/${sellerPid}/c/${cartId}/cart_items`,
      data: {
        product_id: order.productId,
        quantity: order.quantity,
      },
    },
  ).then(function(response) {
    cb(cartPayload(response.data));
  }).
  catch(function() {
    raise_error();
  });
}

export function getCartDetails(cartId, sellerPid, cb) {
  axios(
    {
      method: 'GET',
      url: `/sfdata/s/${sellerPid}/c/${cartId}`,
    },
  ).then(function(response) {
    cb(cartPayload(response.data));
  }).
  catch(function() {
    raise_error();
  });
}

export function removeProductFromServerCart(cartId, sellerPid, productId, cb) {
  axios(
    {
      method: 'DELETE',
      url: `/sfdata/s/${sellerPid}/c/${cartId}/cart_items/${productId}`,
    },
  ).then(function(response) {
    cb(cartPayload(response.data));
  }).catch(function() {
    raise_error();
  });
}

export function updateQuantityOnServerCart(cartId, sellerPid, order, cb) {
  axios(
    {
      method: 'PUT',
      url: `/sfdata/s/${sellerPid}/c/${cartId}/cart_items/${order.productId}`,
      data: {
        quantity: order.quantity,
      },
    },

  ).then(function(response) {
    cb(cartPayload(response.data));
  })
    .catch(function() {
      raise_error();
    });
}

export function addCustomerDetails(cartPid, sellerPid, orderDetails, cb, errorCb) {
  axios({
    method: 'PUT',
    url: `/sfdata/s/${sellerPid}/c/${cartPid}/customer_details`,
    data: {
      order_details: {
        first_name: orderDetails.firstName,
        last_name: orderDetails.lastName,
        mobile: orderDetails.mobile,
        email_address: orderDetails.emailAddress,
        shipping_method: orderDetails.shippingMethod,
      },
    }},
  ).then(function() {
    cb();
  })
    .catch(function(response) {
      errorCb(response);
    });

}

export function fetchCartPreferences(cartPid, sellerPid, cb) {
  axios({
    method: 'GET',
    url: `/sfdata/s/${sellerPid}/c/${cartPid}/checkout_options`,
  }).then(function(response) {
    cb(response.data.preferences);
  })
    .catch(function() {
      raise_error();
    });

}

export function addShippingDetails(cartPid, sellerPid, shippingDetails, cb) {
  axios({
    method: 'PUT',
    url: `/sfdata/s/${sellerPid}/c/${cartPid}/shipping_details`,
    data: {
      method: shippingDetails.method,
      shipping_details: {
        unit_number: shippingDetails.unitNumber,
        street_number: shippingDetails.streetNumber,
        street_name: shippingDetails.streetName,
        suburb: shippingDetails.suburb,
        state: shippingDetails.state,
        post_code: shippingDetails.postCode,
      },
    }},
  ).then(function() {
    cb();
  });
}

export function addNote(cartPid, sellerPid, note, cb) {
  axios({
    method: 'PUT',
    url: `/sfdata/s/${sellerPid}/c/${cartPid}/note`,
    data: {
      note: note,
    }},
  ).then(function() {
    cb();
  });
}

export function createOrder(cartPid, sellerPid, paymentMethod, cb) {
  axios({
    method: 'PUT',
    url: `/sfdata/s/${sellerPid}/c/${cartPid}/payment_details`,
    data: {
      payment_method: paymentMethod,
    }},
  ).then(function(response) {
    cb(response.data.reference);
  });
}

export function listProducts(options, callback) {
  let url = `/sfdata/s/${options.sellerPid}/products/` +
    `?category_id=${options.categoryId ? options.categoryId : ''}` +
    `&keyword=${options.searchKeyword ? options.searchKeyword : ''}` +
    `&page=${options.pageNum ? options.pageNum : '1'}` +
    `&per_page=${options.perPage ? options.perPage : ''}`;

  if (options.buyerId) {
    url = url + `&buyer_id=${options.buyerId}`;
  }

  axios({
    method: 'GET',
    url: url,
  }).then(function(response) {
    callback(response.data);
  });
}

export function listCategories(options, callback) {
  let url = `/sfdata/s/${options.sellerPid}/categories/` +
      `?category_id=${options.categoryId ? options.categoryId : ''}` +
      `&keyword=${options.searchKeyword ? options.searchKeyword : ''}` +
      `&page=${options.pageNum ? options.pageNum : '1'}` +
      `&per_page=${options.perPage ? options.perPage : ''}`;

  if (options.buyerId) {
    url = url + `&buyer_id=${options.buyerId}`;
  }

  axios({
    method: 'GET',
    url: url,
  }).then(function(response) {
    callback(response.data);
  });
}

export function fetchProduct(productId, sellerPid, buyerId, callback) {
  let url = `/sfdata/s/${sellerPid}/products/${productId}`;

  if (buyerId) {
    url = url + `?buyer_id=${buyerId}`;
  }

  axios({
    method: 'GET',
    url: url,
  }).then(function(response) {
    callback(response.data);
  });
}

export function generatePaymentIntentpath(cartPid, sellerPid) {
  return `/sfdata/s/${sellerPid}/c/${cartPid}/create_payment_intent`;
}

